import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { TankService } from 'src/app/services/tank.service';
import { VehicleService } from 'src/app/services/vehicle.service';
import { Vehicle } from 'src/app/shared/models/Vehicle';

@Component({
  selector: 'app-vehicle-page',
  templateUrl: './vehicle-page.component.html',
  styleUrls: ['./vehicle-page.component.css']
})
export class VehiclePageComponent implements OnInit {
  vehicleForm: FormGroup;
  titulo = 'Crear vehiculo para: ';
  tankName: string;
  tankId: number;
  id: number;

  constructor(private fb: FormBuilder, private router: Router, private activatedRoute: ActivatedRoute, private vehicleService: VehicleService,
    private _tankService: TankService) {
    this.vehicleForm = this.initVehiclceForm();
    this.id = parseInt(this.activatedRoute.snapshot.paramMap.get('id'), 10);
  }

  ngOnInit() {
    //this.initializeEditMode();

    this._tankService.getCurrentTank().subscribe((tank) => {
      this.tankName = tank.name;
      this.tankId = tank.id;

      this.initializeEditMode();
    });

  }

  saveVehicle() {
    if (this.vehicleForm.invalid) {
      return;
    }

    const vehicle: Vehicle = this.vehicleForm.value;
    vehicle.tankId = this.tankId;

    console.log("vehicle id: ", this.id);

    const saveOrUpdate = this.id
      ? this.vehicleService.editVehicle(this.id, vehicle)
      : this.vehicleService.saveVehicle(vehicle);

    saveOrUpdate.subscribe(
      () => this.router.navigate(['/vehicles']),
      (error) => {
        console.log(error);
        this.vehicleForm.reset();
      }
    );
  }

  private initVehiclceForm(): FormGroup {

    return this.fb.group({
      id: [''],
      name: [''],
      model: [''],
      year: [''],
      businessName: [''],
      brand: [''],
      plate: [''],
      driver: [''],
      hoursOfUse: [''],
      entryDate: [''],
      tankId: [''],
      razon_social: [''],
    });
  }

  private initializeEditMode() {
    if (this.id) {
      this.titulo = 'Editar Vehiculo para el tanque: ';
      /*this.vehicleService.getVehicleByTank(this.tankId).subscribe((data) => {
        this.vehicleForm.patchValue(data);
      });*/
      this.vehicleService.getVehicleByTank(this.tankId).subscribe((data) => {
        // Filtrar vehículos por vehicle.id igual a this.id
        const filteredVehicles = data.filter(vehicle => vehicle.id === this.id);
        // Aplicar patchValue solo al primer vehículo en el array filtrado
        if (filteredVehicles.length > 0) {
          this.vehicleForm.patchValue(filteredVehicles[0]);
        } else {
          // Manejar el caso en el que no se encontró ningún vehículo con el id especificado
          console.log('No se encontró ningún vehículo con el ID especificado.');
        }
      });
    }
  }
}
